export default "__VITE_ASSET__DKx_rK5K__"